export const SET_WEB3_PROVIDER = "SET_WEB3_PROVIDER";
export const STREAM_CREATED = "STREAM_CREATED";
